import { FC } from 'react';
import { Redirect, useLocation } from 'react-router';

import { PricingPlan } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';
import { MULTI_WALLET_UPGRADE_MODAL } from 'common/upgrade/constants';
import Stepper from 'components/Stepper';
import { StepOptions } from 'components/Stepper/types';
import { SupportedFeaturePreview } from 'features/Upgrade/types';

import UpgradeFromBankAccountsPageSuccess from './steps/UpgradeFromBankAccountsPageSuccess';
import UpgradeInsuranceTermsAndCondition from './steps/UpgradeInsuranceTermsAndCondition';
import UpgradeSuccess from './steps/UpgradeSuccess';
import UpgradeSummary from './steps/UpgradeSummary';

interface LocationState {
  featurePreview?: SupportedFeaturePreview;
  pricingPlan: Pick<PricingPlan, 'brandName' | 'providerPlanId'>;
  from?: string;
}

const ConfirmUpgrade: FC = () => {
  const { state } = useLocation<LocationState>();
  const { companyProfileId } = useCompanyContext();

  if (!state || !state.pricingPlan) {
    return <Redirect to="/upgrade/choice" />;
  }

  const steps: StepOptions[] = [
    {
      key: 'upgrade-summary',
      render: (props) => (
        <UpgradeSummary
          {...props}
          providerPlanId={state.pricingPlan.providerPlanId}
        />
      ),
    },
    {
      key: 'upgrade-insurance-terms-and-condition',
      render: (props) => (
        <UpgradeInsuranceTermsAndCondition
          {...props}
          providerPlanId={state.pricingPlan.providerPlanId}
        />
      ),
    },
    {
      key: 'upgrade-success',
      render: (props) =>
        state.from === MULTI_WALLET_UPGRADE_MODAL && companyProfileId ? (
          <UpgradeFromBankAccountsPageSuccess
            {...props}
            companyProfileId={companyProfileId}
            planName={state.pricingPlan.brandName}
          />
        ) : (
          <UpgradeSuccess
            {...props}
            featurePreview={state.featurePreview}
            planName={state.pricingPlan.brandName}
          />
        ),
    },
  ];

  return <Stepper steps={steps} />;
};

export default ConfirmUpgrade;
